import Banner from './HomeBanner';
export default Banner;